import {colors} from '../core/dark.colors.style';
import {padding} from '../core/padding.style';
import {fontSize} from '../core/fontSize.style';

export const dark = {
  preferences: {
    template: 'dark',
    homePage: {
      header: true,
      aboutUs: {
        show: true,
        content: {
          header: false,
          logo: true,
          contact: true,
          orderButton: true
        }
      },
      ourFood: false,
      getInTouch: false,
      restaurantPanel: false
    }
  },
  primaryColor: colors.C2,
  secondaryColor: colors.C1,
  tertiaryColor: colors.C3,
  quaternaryColor: colors.C4,
  quinaryColor: colors.C5,
  linkColor: colors.C8,
  primaryBackground: colors.BC1,
  secondaryBackground: colors.BC2,
  tertiaryBackground: colors.BC3,
  quaternaryBackground: colors.BC4,
  quinaryBackground: colors.C5,
  padding: padding.padding12,
  margin: padding.padding12,
  letterSpacing: '0.1rem',
  disabledButtonBackground: colors.C2a,
  disabledButtonHoverBackground: colors.C10,
  disabledTextColor: colors.C11,

  // Fonts
  primaryFontFamily: '\'Lato\', Helvetica, Arial, sans-serif',
  fontSize: fontSize.size16,
  lineHeight: '2.4rem',
  textShadow: '0 0 0.8rem #000000',

  // border
  borderColor: colors.BD1,
  borderColorRevert: colors.BD2,
  borderWidth: '0.1rem',

  fontSizes: {
    pageTitle: fontSize.size24,
    error: fontSize.size18
  },

  loading: {
    light: colors.C1,
    dark: colors.C2
  },

  // Container sizes
  container: {
    wider: {
      width: '128rem',
      margin: '1.6rem auto'
    },
    wide: {
      width: 'auto',
      margin: '1.2rem'
    },
    desktop: {
      width: 'auto'
    },
    tablet: {
      width: 'auto'
    },
    phone: {
      width: 'auto',
      margin: 0
    }
  },

  // CommonContent
  content: {
    margin: '0 auto',
    padding: padding.padding24,
    width: '100%'
  },

  // Home page
  homePage: {
    title: {
      fontSize: fontSize.size22,
      fontWeight: 900
    },
    width: '53rem',
    background: colors.BC5,
    color: colors.C2,
    offsetTop: '4.6rem',
    padding: '2.4rem',
    mobile: {
      margin: 0
    },
    container: {
      margin: 0
    },
    linkColor: colors.C8,
    border: 0,
    contact: {
      padding: padding.padding06
    },
    parsedContent: {
      fontSize: fontSize.size16,
      background: 'none',
      padding: padding.padding12,
      h: {
        display: 'none',
        width: 0,
        minWidth: 0,
        height: 0,
        border: 'none',
        margin: 0
      }
    },
    panelContent: {
      background: colors.BC2,
      button: {
        fontSize: fontSize.size14,
        color: colors.C2,
        margin: '1rem auto',
        padding: '0.8rem 2rem 0.6rem',
        width: '34rem',
        backgroundColor1: colors.C3,
        backgroundColor2: colors.C4,
        hoverColor1: colors.C3a,
        hoverColor2: colors.C4a,
        radius: '0.6rem'
      }
    },
    actionPanel: {
      background: colors.BC3
    },
    facebookLike: {
      background: colors.BC5,
      color: colors.C2,
      padding: '0 0 2.4rem 0',
      maxWidth: '53rem',
      mobile: {
        margin: '0 0 2.4rem',
        maxWidth: 'unset'
      }
    },
    header: {
      fontSize: fontSize.size24
    }
  },

  orderNow: {
    color: colors.C2,
    backgroundColor: colors.BC6,
    hoverColor: colors.BC7,
    lineHeight: '4rem',
    fontSize: fontSize.size20,
    margin: '0 -1.2rem -1.2rem',
    iconSize: '2.4rem',
    padding: '2rem 1rem'
  },

  // Hr
  hr1Color: colors.C6,

  h1: {
    fontSize: fontSize.size36,
    lineHeight: '4rem'
  },

  h2: {
    fontSize: '3rem',
    lineHeight: '3rem'
  },

  header: {
    fontSize: fontSize.size15,
    mobileFontSize: fontSize.size12,
    lineHeight: '1.8rem',
    linkPadding: {
      large: '2rem 1rem',
      small: padding.padding06
    },
    hoverColor: colors.C4,
    maxWidth: '73rem',
    backgroundColor: colors.BC7,
    logo: {
      maxHeight: '10rem',
      maxWidth: '24rem',
      radius: '0.6rem',
      fontSize: '2em',
      tabletFontSize: '1.5em',
      mobileFontSize: '1em'
    },
    locate: {
      fontSize: fontSize.size18,
      hoverColor: colors.C1a
    },
    content: {
      wider: {
        margin: '0 auto'
      },
      wide: {
        margin: '0 1.2rem'
      },
      small: {
        margin: '0'
      }
    }
  },

  footer: {
    fontSize: fontSize.size12,
    dotPadding: padding.padding06,
    expand: {
      padding: '6rem'
    }
  },

  //Menu
  menuPage: {
    menu: {
      width: '100%',
      maxWidth: '100%',
      padding: padding.padding12,
      headerPadding: padding.padding12,
      backgroundColor: 'transparent'
    },
    closedMessage: {
      backgroundColor: colors.C5,
      color: colors.C1,
      margin: '1.2rem'
    },
    tabletView: {
      padding: 0
    },
    categoryGap: padding.padding12,
    nav: {
      display: {
        desktop: 'block',
        tablet: 'none'
      },
      width: '21rem',
      maxWidth: '100%',
      height: 'auto',
      wrapperPadding: 0,
      padding: padding.padding12,
      fontSize: fontSize.size18,
      textTransform: 'none',
      fontFamily: 'inherit',
      fontWeight: 100,
      lineHeight: '1.6rem',
      color: colors.C5,
      backgroundColor: colors.BC1
    },
    basket: {
      width: '32rem',
      fontSize: fontSize.size24,
      padding: '2.4rem 1.2rem',
      total: {
        fontSize: fontSize.size18,
        fontFamily: 'inherit',
        backgroundColor: colors.BC12,
        padding: padding.padding12,
        color: colors.C4,
        border: `${colors.BD1} 0.1rem solid`,
        letterSpacing: 0,
        textTransform: 'none'
      }
    }
  },

  category: {
    borderBottom: 0,
    promotionOnTop: {
      display: 'none'
    },
    header: {
      backgroundColor: colors.BC3,
      name: {
        fontSize: {
          desktop: fontSize.size24,
          mobile: fontSize.size22
        },
        textTransform: 'none',
        letterSpacing: 0,
        lineHeight: '2.4rem'
      },
      icon: {
        top: '1.2rem',
        right: '1.2rem'
      },
      description: {
        height: '2.4rem',
        fontSize: fontSize.size14,
        textTransform: 'capitalize',
        padding: padding.padding12
      }
    }
  },

  meal: {
    width: '100%',
    margin: 0,
    fontFamily: 'inherit',
    border: `0.1rem solid ${colors.BD1}`,
    name: {
      fontSize: fontSize.size20
    },
    description: {
      fontSize: fontSize.size16,
      lineHeight: '2rem'
    },
    arrow: {
      display: 'flex'
    },
    footer: {
      display: 'none',
      height: 0
    },
    addToBasket: {
      padding: '0 0.5rem',
      width: '5rem',
      fontSize: fontSize.size14,
      display: 'block'
    },
    price: {
      fontSize: fontSize.size18,
      color: colors.C4
    }
  },

  compactMeal: {
    backgroundColor: colors.BC12
  },

  // Contact page
  contactPage: {
    width: '53rem',
    backgroundColor: colors.BC5,
    offsetTop: '4.6rem',
    fontSize: fontSize.size14,

    facebookLike: {
      background: colors.BC5,
      color: colors.C2,
      padding: '0 0 2.4rem 0',
      maxWidth: '53rem',
      mobile: {
        margin: '0 auto 2.4rem'
      }
    }
  },

  // Gallery page
  galleryPage: {
    width: '53rem',
    backgroundColor: colors.BC5,
    offsetTop: '4.6rem',
    mealCard: {
      fontSize: '1.6rem',
      padding: padding.padding12,
      borderColor: '#d55b1a',
      image: {
        width: '18rem',
        height: '18rem'
      },
      orderNowBtn: {
        backgroundColor: colors.C1,
        backgroundHoverColor: '#ea8752'
      }
    }
  },

  promotion: {
    fontSize: fontSize.size16,
    fontWeight: 'bold',
    margin: {
      desktop: '0 1.2rem 1.2rem'
    }
  },

  // Reviews page
  reviewsPage: {
    width: '53rem',
    backgroundColor: colors.BC5,
    offsetTop: '4.6rem',
    linkColor: colors.C2
  },

  // Confirmation page
  confirmationPage: {
    width: '53rem',
    backgroundColor: colors.BC5,
    linkColor: colors.C1,
    border: 0,
    trackerBlock: {
      width: '100%',
      marginBottom: 0
    },
    summaryBlock: {
      margin: 0,
      textTransform: 'unset',
      padding: 0
    },
    infoBlock: {
      justifyContent: 'center'
    }
  },

  orderTracker: {
    iconColor: {
      active: colors.C1,
      inactive: colors.BC9
    },
    textColor: colors.C2,
    size: '6.4rem'
  },

  progressBar: {
    color: colors.C1,
    backgroundColor: colors.BC9
  },

  basketPanelItem: {
    padding: `${padding.padding06} ${padding.padding12}`
  },

  basketModal: {
    padding: padding.padding24,
    borderColor: colors.BD3,
    content: {
      maxHeight: 'calc(100vh - 20rem)'
    },
    footer: {
      backgroundColor: colors.BC10
    }
  },

  basketItem: {
    background: colors.BC1,
    lineHeight: '1.8rem',
    width: {
      desktop: '70rem',
      tablet: '54rem',
      phone: '100%'
    },
    text: {
      fontSize: fontSize.size18,
      fontWeight: 'normal'
    },
    subtitle: {
      textAlign: 'left',
      transform: 'none'
    },
    description: {
      fontSize: fontSize.size14,
      color: colors.C9
    },
    size: {
      fontSize: fontSize.size14,
      color: colors.C10
    },
    selected: {
      color: colors.C1,
      backgroundImage: 'linear-gradient(to bottom, #d97d4a, #d97d4a)',
      backgroundColor: colors.C1,
      boxShadow: '0 3px 0 #c66332'
    },
    optionsGroup: {
      fontSize: fontSize.size18,
      color: colors.C10,
      lineHeight: '4.4rem',
      backgroundColor: colors.BC9,
      boxShadow: 'inset 0 3px 0 rgba(0, 0, 0, 0.07)',
      textAlign: 'left'
    },
    comment: {
      backgroundColor: colors.BC9,
      height: '7rem'
    },
    optionsGroupInfo: {
      fontSize: fontSize.size14,
      color: colors.C2a
    },
    option: {
      lineHeight: '4.4rem',
      display: 'none',
      fontSize: fontSize.size14,
      padding: padding.padding06,
      borderRadius: '0.7rem',
      margin: '0.2rem 0.2rem 0.4rem',
      backgroundImage: 'linear-gradient(to bottom, #dcdcd7, #e4e4df)',
      boxShadow: 'inset 0 3px 0 rgba(0, 0, 0, 0.07)',
      backgroundColor: 'none'
    },
    quantity: {
      block: {
        size: '4.4rem'
      },
      fontSize: fontSize.size20,
      color: colors.C2,
      hoverColor: colors.C2,
      width: '13.2rem'
    }
  },

  sideBasket: {
    backgroundColor: colors.BC7,
    color: colors.C4,
    margin: '0 0 auto',
    option: {
      fontFamily: 'inherit',
      fontWeight: 100,
      fontSize: fontSize.size14,
      color: colors.C9,
      lineHeight: 'inherit',
      margin: '2.6rem'
    },
    item: {
      margin: 0,
      padding: padding.padding12,
      fontSize: fontSize.size16
    },
    special: {
      fontFamily: 'inherit',
      fontSize: fontSize.size12,
      letterSpacing: 0,
      textTransform: 'none'
    },
    header: {
      backgroundColor: colors.BC1,
      fontSize: fontSize.size24,
      color: colors.C5,
      borderTop: 0,
      borderRight: 0,
      borderBottom: `${colors.BD1} solid 0.1rem`
    },
    toggle: {
      size: '4rem',
      cartSize: fontSize.size20,
      arrowSize: fontSize.size14
    },
    closedBackground: colors.C3,
    comments: {
      color: colors.C10
    },
    plusMinus: {
      position: 'relative',
      display: 'block',
      top: 0
    },
    dineIn: {
      padding: {
        mobile: '0 0.4rem'
      },
      message: {
        fontSize: fontSize.size18,
        color: colors.BC10
      },
      link: {
        fontSize: fontSize.size14,
        color: colors.C1a
      }
    },
    summary: {
      backgroundColor: colors.C2,
      padding: padding.padding12,
      borderRight: 0,
      message: {
        padding: 0,
        fontSize: fontSize.size14
      },
      fee: {
        fontWeight: 'bold',
        fontSize: fontSize.size18
      }
    },
    paymentIcon: {
      paddingLeft: 0,
      paddingRight: padding.padding06,
      paddingBottom: 0
    },
    message: colors.C11,
    serviceType: {
      padding: padding.padding12
    },
    serviceTypeRadioButtonNoteColor: colors.C1,
    serviceTypeRadioButtonEtaNoteColor: colors.BC10,
    serviceTypeRadioButtonNoteFontSize: fontSize.size12
  },

  button: {
    size: fontSize.size18,
    x: {
      color: colors.C2,
      backgroundColor: colors.BC8,
      hoverColor: colors.BC8a,
      borderBottom: `2px solid ${colors.BT1}`,
      borderRadius: '0.5rem',
      margin: padding.padding06
    },
    plus: {
      color: colors.C1a,
      backgroundColor: colors.BC11,
      hoverColor: colors.BT2,
      borderBottom: colors.BT2
    },
    primary: {
      hoverColor: colors.C1a,
      hoverTextColor: colors.C2,
      borderBottom: `0.2rem solid ${colors.C1b}`
    },
    secondary: {
      hoverColor: colors.BC9,
      borderBottom: `0.2rem solid ${colors.C9}`
    },
    checkout: {
      backgroundColor: {
        desktop: colors.C1,
        mobile: colors.C1
      },
      color: {
        desktop: colors.C2,
        mobile: colors.C2
      },
      fontFamily: 'inherit',
      fontSize: fontSize.size18,
      fontWeight: 100,
      letterSpacing: 0,
      width: '100%',
      padding: padding.padding12,
      subTitle: {
        fontSize: fontSize.size12
      },
      margin: 0,
      border: 0,
      borderBottom: `0.2rem solid ${colors.C1b}`,
      disabled: {
        backgroundColor: colors.C1,
        color: colors.C10,
        borderBottom: `0.2rem solid ${colors.C1b}`
      }
    }
  },

  checkoutPage: {
    color: '#000',
    bigLabelColor: '#e8773b',
    deliveryAddressLabelColor: '#211c1d',
    inputErrorBackgroundColor: '#F2DEDE',
    inputTextColor: '#979797',
    inputTextBackground: '#f7f7f2',
    inputTextBorderColor: '#e7e7e7',
    inputTextShadowColor: '#b4b4b4',
    smallTextColor: '#a6a6a6',
    requiredMessageColor: '#b94a48',
    paymentsDisclamerBackground: '#fbfbfb',
    formErrorBackground: '#b77a7a',
    formErrorColor: colors.C2,
    deliveryFeeBackgroundColor: colors.BC13,
    linkColor: colors.C8,
    selectedDayBackground: colors.BC14,
    selectedDayColor: colors.C2,
    modalButtonMargin: padding.padding06,
    margin: padding.padding12,
    fontWeight: 'bold',
    borderRight: 0,
    textColor: colors.C4,
    payment: {
      title: {
        fontSize: '1.8rem'
      }
    }
  },

  tableBookingPage: {
    width: '53rem',
    color: colors.C2,
    backgroundColor: colors.BC5,
    offsetTop: '4.6rem',
    padding: '2.4rem',
    title: {
      fontWeight: 'normal'
    },
    subTitle: {
      fontSize: fontSize.size14
    }
  },

  termsPage: {
    backgroundColor: colors.BC5,
    linkColor: colors.C8
  },

  defaultModal: {
    backgroundColor: colors.BC1,
    padding: `${padding.padding24} ${padding.padding12}`,
    color: colors.C10,
    width: {
      desktop: '70rem',
      tablet: '54rem',
      phone: '100%'
    }
  },

  basicPage: {
    width: '53rem',
    minHeight: 'inherit',
    color: colors.C2,
    backgroundColor: colors.BC5,
    linkColor: colors.C1,
    offsetTop: '4.6rem',
    status: {
      lineHeight: '15rem',
      fontSize: '13rem',
      display: 'block'
    },
    sorry: {
      display: 'none'
    },
    fontSize: fontSize.size20
  },

  datePicker: {
    selected: {
      color: colors.C2,
      background: colors.C1
    }
  },

  spinner: {
    c1: '#e7773b',
    c2: '#ed996c',
    c3: '#f3bb9d',
    c4: '#f9ddce',
    margin: 0
  },

  underMaintenancePage: {
    fontSizes: {
      title: fontSize.size24,
      text: fontSize.size18
    }
  },

  upselling: {
    direction: 'column',
    flexWrap: 'inherit',
    backgroundColor: 'inherit',
    buttons: {
      padding: padding.padding24
    }
  },

  feedbackPage: {
    colors: {
      background: colors.BC15,
      yes: colors.C12,
      no: colors.C13,
      unselectedNo: colors.C13a,
      maybe: colors.C1,
      text: colors.C9
    },
    padding: {
      content: '4.4rem 2.4rem',
      question: '2.4rem 2.4rem 0 2.4rem',
      comment: '2.4rem 0',
      mealName: '2.4rem',
      qualityGroup: '0 2.4rem',
      loading: '2.4rem'
    },
    margin: {
      submit: '2.4rem'
    },
    fontSizes: {
      title: fontSize.size24,
      text: fontSize.size20
    }
  }
};



// WEBPACK FOOTER //
// ./styles/themes/dark.js